import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { getBotConfig, getUserId, getIpAddress } from '../../redux'
import operations from '../../redux/operations'

class QuickReply extends React.Component {

  constructor(props) {
    super(props);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.submitMultipleAnswers = this.submitMultipleAnswers.bind(this);
  }

  componentDidMount() {
    const { buttons } = this.props.message.attachments[0].content;
    buttons.forEach(button => {
      this.setState({ [button.data.value]: false })
    })
  }

  handleButtonClick(e, data, value) {
    this.setState({ [value]: !this.state[value] })
  }

  submitMultipleAnswers() {
    const answers = 
    Object
    .keys(this.state)
    .filter(key => this.state[key])
    
    console.log("answers", answers);

    const answerValue = 
    answers
    .map(key => key.split('=')[1])
    .reduce((concatenated, key) => `${concatenated},${key}`)

    const {
      botConfig,
      userId,
      ipAddress,
      sendQuickReply,
      message
    } = this.props;

    const value = `action?postMultiplequickreply=${answerValue}`;

    const { buttons } = message.attachments[0].content;

    console.log("buttons", buttons);

    const data = {};
    data.content =
    answers
    .map(value => buttons.filter(butt => butt.data.value === value)[0].data.title)
    .reduce((concatenated, title, index, array) => (
      array.length === 1 
      ? concatenated
      : (index === array.length - 1
        ? `${concatenated} et ${title.toLowerCase()}`
        : `${concatenated}, ${title.toLowerCase()}`)
    ))

    sendQuickReply(botConfig, value, data, userId, ipAddress);
  }


  render() {
    const {
      message,
      botConfig,
      userId,
      ipAddress,
      sendQuickReply,
    } = this.props;

    const attachment = message.attachments[0]

    // console.log("message", message);

    const values = {...this.state};
    let oneButtonIsClicked = false;
    Object.keys(values).forEach(value => {
      values[value] && (oneButtonIsClicked = true)
    })

    const multiChoice = attachment.content.buttons.filter(button => button.data.type === 'select').length > 0

    return (
      <div style={{ textAlign: 'center', marginBottom: multiChoice && `44px` }}>
        <br />
        {
          attachment.content.buttons.map((button, index) => {
            if (button.data.type === 'openUrl') {
              return (
                <Button
                  basic
                  circular
                  color="blue"
                  as="a"
                  href={button.value}
                  key={`${message.id}-quickreply-${index}`}
                  content={button.data.title}
                />
              )
              } else if (button.data.type === 'postBack') {
                const value = button.data.value
                return (
                  <Button
                    basic
                    circular
                    style={{ marginBottom: '5px' }}
                    onClick={(e, data) => sendQuickReply(botConfig, value, data, userId, ipAddress)}
                    key={`${message.id}-quickrelpy-${index}`}
                    content={button.data.title}
                  />
                )
            } else if (button.data.type === 'select') {
              const value = button.data.value;
              // console.log("value", value);
              // console.log("values[value]", values[value]);
              return (
                <button
                  className={`${values && values[value] ? 'active' : ''} mystyle`} 
                  style={{ 
                    marginBottom: '5px',
                    backgroundColor: 'rgba(101,101,101,1.00) !important',
                    color: '#fff !important',
                    border: 'none !important'
                  }}
                  onClick={(e, data) => this.handleButtonClick(e, data, value)}
                  key={`${message.id}-quickrelpy-${index}`}
                >
                  {button.data.title}
                </button>
              )
            }
            return (null)
          })
        }
        {oneButtonIsClicked && 
          <div className="quickreply-send-button__outer">
            <div className="quickreply-send-button__inner" onClick={this.submitMultipleAnswers}>
              <div className="quickreply-send-button"></div>
            </div>
          </div>
        }
      </div>
    )
  }
}

QuickReply.propTypes = {
  message: PropTypes.object.isRequired,
  botConfig: PropTypes.object.isRequired,
  sendQuickReply: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  ipAddress: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  botConfig: getBotConfig(state),
  userId: getUserId(state),
  ipAddress: getIpAddress(state),
})

export default connect(
  mapStateToProps,
  operations,
)(QuickReply)



// WEBPACK FOOTER //
// ./src/views/components/QuickReply.js